module.exports = __webpack_public_path__ + "acc51d39ed7f30b3806aec8254bed69d.png";